var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLock = function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.97 8.001c-.099-1.627-.453-2.321-.924-2.91-.59-.737-1.333-1.09-2.048-1.09-.714 0-1.459.353-2.048 1.09-.471.589-.825 1.283-.924 2.91zm-5.8-3.536c-.642.803-1.043 1.722-1.146 3.536H4.998a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2h-3.026c-.103-1.814-.504-2.733-1.146-3.536-.75-.937-1.767-1.464-2.828-1.464S9.92 3.528 9.17 4.465M4.998 9.001h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1m8.35 4.765c0 .475-.26.89-.645 1.11v2.078a.638.638 0 0 1-1.275 0v-2.088a1.275 1.275 0 0 1 .619-2.374h.027c.704 0 1.275.57 1.275 1.274",
    clipRule: "evenodd"
  })));
};
export default SvgIconLock;